import React, {FC, useEffect} from 'react';
import './style.scss';
import NavBarItem from '../NavBarItem';
import {useHistory, useLocation} from 'react-router-dom';
import home from '../../assets/img/navbar/navbar_main.svg'
import homeActive from '../../assets/img/navbar/navbar_main--active.svg'
import mixer from '../../assets/img/navbar/navbar_mixer.svg'
import mixerActive from '../../assets/img/navbar/navbar_mixer--active.svg'
import favorite from '../../assets/img/navbar/navbar_favorite.svg'
import favoriteActive from '../../assets/img/navbar/navbar_favorite--active.svg'
import {FAVORITE_PATH, MAIN_PATH, MIXER_PATH} from "../../constants";

interface INavBar {
    activePage: string,
    setActivePage: any
}

const NavBar: FC<INavBar> = ({activePage, setActivePage}) => {
    const history = useHistory();
    const {pathname} = useLocation();

    useEffect(() => {
        setActivePage(pathname.slice(1).toLocaleUpperCase())
    }, [pathname, setActivePage]);

    const clickHandler = (pathUrl: string) => {
        history.push(`/${pathUrl.toLowerCase()}`);
    };

    return (
        <div className="navbar">
            <NavBarItem
                icon={home}
                activeIcon={homeActive}
                activePage={activePage}
                currentPage={MAIN_PATH}
                onClick={() => clickHandler(MAIN_PATH)}
            >
                Главная
            </NavBarItem>
            <NavBarItem
                icon={mixer}
                activeIcon={mixerActive}
                activePage={activePage}
                currentPage={MIXER_PATH}
                onClick={() => clickHandler(MIXER_PATH)}
            >
                Миксер
            </NavBarItem>
            <NavBarItem
                icon={favorite}
                activeIcon={favoriteActive}
                activePage={activePage}
                currentPage={FAVORITE_PATH}
                onClick={() => clickHandler(FAVORITE_PATH)}
            >
                Любимое
            </NavBarItem>
        </div>
    )
};

export default NavBar;
